import IO from 'socket.io-client'
import clientConfig from '@/../public/client_config.json'

/**
 * Connection code for socket to Node Client Server.
 */
export let connection = {
  socket: null,
  config: {},
  getConnectionString(service) {
    return `${this.config[service].host}${this.config[service].port ? `:${this.config[service].port}` : ''}`
  }
}

const location = `//${window.location.hostname}`

connection.config = (process.env.NODE_ENV === 'development')
? clientConfig.development
: clientConfig.production || {}

const replaceUndefinedWithAuto = (conf, arr) => arr.reduce((acc, val) => {
  if(!(conf[val] && conf[val].host)) {
    acc[val] = Object.assign({}, acc[val] || {}, {host: location})
  }

  return acc
}, conf)

const httpCodes = [
  { code: 100, description: 'Continue' },
  { code: 101, description: 'Switching Protocols' },
  { code: 102, description: 'Processing' },
  { code: 200, description: 'OK' },
  { code: 201, description: 'Created' },
  { code: 202, description: 'Accepted' },
  { code: 203, description: 'Non-authoritative Information' },
  { code: 204, description: 'No Content' },
  { code: 205, description: 'Reset Content' },
  { code: 206, description: 'Partial Content' },
  { code: 207, description: 'Multi-Status' },
  { code: 208, description: 'Already Reported' },
  { code: 226, description: 'IM Used' },
  { code: 300, description: 'Multiple Choices' },
  { code: 301, description: 'Moved Permanently' },
  { code: 302, description: 'Found' },
  { code: 303, description: 'See Other' },
  { code: 304, description: 'Not Modified' },
  { code: 305, description: 'Use Proxy' },
  { code: 307, description: 'Temporary Redirect' },
  { code: 308, description: 'Permanent Redirect' },
  { code: 401, description: 'Unauthorized' },
  { code: 400, description: 'Bad Request' },
  { code: 402, description: 'Payment Required' },
  { code: 403, description: 'Forbidden' },
  { code: 404, description: 'Not Found' },
  { code: 405, description: 'Method Not Allowed' },
  { code: 406, description: 'Not Acceptable' },
  { code: 407, description: 'Proxy Authentication Required' },
  { code: 408, description: 'Request Timeout' },
  { code: 409, description: 'Conflict' },
  { code: 410, description: 'Gone' },
  { code: 411, description: 'Length Required' },
  { code: 412, description: 'Precondition Failed' },
  { code: 413, description: 'Payload Too Large' },
  { code: 414, description: 'Request-URI Too Long' },
  { code: 415, description: 'Unsupported Media Type' },
  { code: 416, description: 'Requested Range Not Satisfiable' },
  { code: 417, description: 'Expectation Failed' },
  { code: 418, description: 'I am a teapot' },
  { code: 421, description: 'Misdirected Request' },
  { code: 422, description: 'Unprocessable Entity' },
  { code: 423, description: 'Locked' },
  { code: 424, description: 'Failed Dependency' },
  { code: 426, description: 'Upgrade Required' },
  { code: 428, description: 'Precondition Required' },
  { code: 429, description: 'Too Many Requests' },
  { code: 431, description: 'Request Header Fields Too Large' },
  { code: 444, description: 'Connection Closed Without Response' },
  { code: 451, description: 'Unavailable For Legal Reasons' },
  { code: 499, description: 'Client Closed Request' },
  { code: 500, description: 'Internal Server Error' },
  { code: 501, description: 'Not Implemented' },
  { code: 502, description: 'Bad Gateway' },
  { code: 503, description: 'Service Unavailable' },
  { code: 504, description: 'Gateway Timeout' },
  { code: 505, description: 'HTTP Version Not Supported' },
  { code: 506, description: 'Variant Also Negotiates' },
  { code: 507, description: 'Insufficient Storage' },
  { code: 508, description: 'Loop Detected' },
  { code: 510, description: 'Not Extended' },
  { code: 511, description: 'Network Authentication Required' },
  { code: 599, description: 'Network Connect Timeout Error' }
]


connection.config = replaceUndefinedWithAuto(connection.config, ['server', 'microservice', 'sso'])
console.log(`Connecting to ${connection.getConnectionString('server')}`)
connection.socket = new IO(connection.getConnectionString('server'))

export var SocketHandler = {
  data() {
    return {
      connection
    }
  },
  methods: {
    SocketMessageSend(Message) {
      if(clientConfig.debug) console.log('%c --> socket message: ', 'color: "magenta"', Message)

      this.connection.socket.emit('message', Message)

      const opers = ['Upd', 'Del', 'Add', 'Ins']

      if(opers.includes(Message.Oper)) this.$emit('SetPageMessage', { target: 'StatusElement', type: 'saving' })
    },
    socketMessageRepack(Message) {
      let rtn = null

      if (Message && Message.data) {
        const data = Message.data.data ? Message.data.data : Message.data

        if (data) { // Type not required
          rtn = {
            component: Message.data.component,
            type: Message.data.type,
            command: Message.data.command,
            category: Message.data.category,
            code: Message.data.data ? Message.data.data.code : null,
            data
          }
        }
      }

      return rtn
    }
  }
}

const lifeCycleAbort = () => {
  console.error('LifeCycle: Component Name is undefined, communication aborted')
  return
}

export var LifeCycle = {
  created() {
    if (this.$options.name == undefined) {
      lifeCycleAbort
    }

    this.SocketMessageSend({ component: this.$options.name, command: 'Created' })
  },
  mounted() {
    if (this.$options.name == undefined) {
      lifeCycleAbort
    }

    this.SocketMessageSend({ component: this.$options.name, command: 'Mounted' })
  },
  destroyed() {
    if (this.$options.name == undefined) {
      lifeCycleAbort
    } else if (this.$options.name === 'JSControl') {
      this.SocketMessageSend({ component: this.$options.name, command: 'Destroyed', path: window.location.href })
    } else {
      this.SocketMessageSend({ component: this.$options.name, command: 'Destroyed' })
    }
  }
}

import axios from 'axios'

const axiosInstance = axios.create({
  timeout: 10000,
  baseURL: connection.getConnectionString('microservice')
})

let _parameters = {
  controller: null,
  typeName: null
}

export const MicroService = {
  microService: {
    _instance: axiosInstance,
    _parameters
  },
  data() {
    return {
      microService: {
        _instance: axiosInstance,
        _parameters
      }
    }
  },
  methods: {
    setMicroServiceParameters(controller, typeName) {
      if (controller && typeName) {
        this.microService._parameters.controller = controller
        this.microService._parameters.typeName = typeName.toLowerCase()
      } else {
        console.warn('Incorrect setMicroServiceParameters', controller, typeName)
      }
    },
    setMicroServiceAuth(auth) {
      this.microService._instance.defaults.headers.common['Authorization'] = auth
    },
    sendMicroServiceRequest(options) {
      if (clientConfig.debug) console.log('%c MSR --> ', 'color: "magenta"', options)

      const headers = this.microService._instance.defaults.headers
      const controller = this.microService._parameters.controller
      const typeName = this.microService._parameters.typeName

      if (!headers && controller !== null && typeName !== null) {
        console.error(
          'Mixins microService(): Expected Authorization header, id and typename to be set, got:',
          'headers: ', headers.common,
          'controllerID: ', controller,
          'typeName: ', typeName
        )
        return
      }
      if (!(options.method && options.url)) {
        console.error('Mixins microService(): Expected method and url to be set, got:', options)
        return
      }

      let url = new URL(`http://baseurl/${options.url}`) // @NOTE: faking origin so we can use the URL constructor (protocol doesn't matter)

      // console.log('WHERE AM I? ' + this.$options.name)

      if (this.$options.name != 'Admin') {
        // stop sending these stupid appended fields if we are on the Admin page - jimm 4.aug.2021
        url.searchParams.append('controllerID', controller)
        url.searchParams.append('typeName', typeName)
      }

      options.url = `${url.pathname}${url.search}`

      const statusElementError = {
        target: 'StatusElement',
        type: 'error',
        data: 'MS-ERR'
      }
      const statusElementChange = {
        target: 'StatusElement',
        type: 'saving'
      }
      // const statusElementComplete = {
      //   target: 'StatusElement',
      //   type: 'complete'
      // }

      const isUpdate = options.method === 'PUT' || options.method === 'POST'

      if(isUpdate) {
        this.$emit('SetPageMessage', statusElementChange)
        if (clientConfig.debug) console.log('%c MSR <-- ', 'color: "magenta"', JSON.stringify(statusElementChange))
        
        this.$root.$emit('extendtime')
      }


      return this.microService._instance
      .request(options)
      .catch((err) => {
        console.warn('err is: ' + JSON.stringify(err, null, 2))
        if(err.message === 'Network Error') // Likely timeout
          statusElementError.data += ':NETERR'
        else if(err.response)
          err.response.status += ' ' + httpCodes.find(c => c.code == err.response.status).description
          statusElementError.data += err.response.status ? `:${err.response.status}` : ''

        this.$emit('SetPageMessage', statusElementError)
        if (clientConfig.debug) console.error('%c MSR <-- ERROR: ', 'color: "magenta"', statusElementError)

      })
    }
  }
}

import convert from '@bstoots/convert-units'
export const UnitSystem = {
  methods: {
    unitsInMetric() { // This should be a computed value, but then it'd be undefined when calculating data values
      if (!this.store) throw new Error('no store')

      const storeData = this.store.getData('systemCapabilities.units').toLowerCase()
      return storeData
        ? storeData === 'metric'
        : null
    },
    convertUnits(val, from, to) {
      val = val ? parseFloat(val) : 0
      if (!this.unitsInMetric()) return + val.toFixed(2) // Already in imperial

      const err = () => {
        console.warn('cannot convert', val, from, to)
        return null
      }

      return typeof val === 'number' && typeof from === 'string' && typeof to === 'string'
        ? +convert(val).from(from).to(to).toFixed(2) // A large amount of the code expects the server to return strings only so here's a string conversion (+)
        : err()
    },
    getDenominator(metricDenominator, imperialDenominator, plural) {
      const use = this.unitsInMetric()
        ? metricDenominator
        : imperialDenominator
      return this.$tc(`messages.sharedTexts.units.${use}`, plural)
    }
  }
}
